(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var SPIN = 'is-loading';

    function setLoading(el, on) {
      if (on) {
        el.classList.add(SPIN);
        el.disabled = true;
      } else {
        el.classList.remove(SPIN);
        el.disabled = false;
      }
    }

    function cartChange(key, qty, triggerEl) {
      setLoading(triggerEl, true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(key), quantity: qty })
      })
        .then(function () { window.location.reload(); })
        .catch(function () { window.location.reload(); });
    }

    /* ---- Minus ---- */
    document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = this.closest('.cart-qty').querySelector('.cart-qty-num');
        var key = input.name.replace('updates[', '').replace(']', '');
        var val = parseInt(input.value, 10) || 0;
        if (val > 1) cartChange(key, val - 1, this);
      });
    });

    /* ---- Plus ---- */
    document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = this.closest('.cart-qty').querySelector('.cart-qty-num');
        var key = input.name.replace('updates[', '').replace(']', '');
        var val = parseInt(input.value, 10) || 0;
        cartChange(key, val + 1, this);
      });
    });

    /* ---- Remove (trash icon) ---- */
    document.querySelectorAll('[data-qty-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-qty-remove');
        cartChange(key, 0, this);
      });
    });

    /* ---- Manual input change ---- */
    document.querySelectorAll('.cart-qty-num').forEach(function (input) {
      input.addEventListener('change', function () {
        var val = parseInt(this.value, 10);
        if (isNaN(val) || val < 0) val = 0;
        var key = this.name.replace('updates[', '').replace(']', '');
        var btn = this.closest('.cart-qty').querySelector('[data-qty-plus]');
        cartChange(key, val, btn || this);
      });
    });

    /* ---- Upsell (increment existing item) ---- */
    var upsellBtn = document.querySelector('[data-upsell]');
    if (upsellBtn) {
      upsellBtn.addEventListener('click', function () {
        var key = this.getAttribute('data-upsell-key');
        var cur = parseInt(this.getAttribute('data-upsell-qty'), 10) || 0;
        var add = parseInt(this.getAttribute('data-upsell-add'), 10) || 1;
        cartChange(key, cur + add, this);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Nav scroll background */
  window.addEventListener("scroll", function() {
    var n = document.querySelector("nav");
    if (n) {
      n.style.background = window.scrollY > 100
        ? "rgba(10,10,10,0.97)"
        : "linear-gradient(to bottom,rgba(10,10,10,0.95),rgba(10,10,10,0))";
      n.style.backdropFilter = window.scrollY > 100 ? "blur(10px)" : "none";
    }
  });

  /* Mobile drawer toggle */
  (function() {
    var hamburger = document.getElementById("navHamburger");
    var drawer = document.getElementById("navDrawer");
    var overlay = document.getElementById("navOverlay");
    var closeBtn = document.getElementById("navDrawerClose");

    function openDrawer() {
      drawer.classList.add("open");
      overlay.classList.add("open");
      drawer.setAttribute("aria-hidden", "false");
      hamburger.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    }

    function closeDrawer() {
      drawer.classList.remove("open");
      overlay.classList.remove("open");
      drawer.setAttribute("aria-hidden", "true");
      hamburger.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }

    if (hamburger) hamburger.addEventListener("click", openDrawer);
    if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
    if (overlay) overlay.addEventListener("click", closeDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-question").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = this.parentElement;
      var wasOpen = item.classList.contains("open");
      document.querySelectorAll(".faq-item").forEach(function (i) {
        i.classList.remove("open");
      });
      if (!wasOpen) item.classList.add("open");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["potions-recipes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var tabs = document.querySelectorAll(".filter-tab");
    var cards = document.querySelectorAll(".recipe-card");
    var featured = document.getElementById("potions-featured");
 
    tabs.forEach(function(tab) {
      tab.addEventListener("click", function() {
        var cat = this.getAttribute("data-filter");
 
        tabs.forEach(function(t) { t.classList.remove("active"); });
        this.classList.add("active");
 
        if (cat === "all") {
          if (featured) featured.style.display = "";
          cards.forEach(function(c) { c.style.display = ""; });
        } else {
          if (featured) featured.style.display = "none";
          cards.forEach(function(c) {
            if (c.getAttribute("data-cat") === cat) {
              c.style.display = "";
            } else {
              c.style.display = "none";
            }
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["potions-submit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.js-potions-submit').forEach(function (root) {
      var apiKey      = root.getAttribute('data-imgbb-key') || '';
      var fileInput   = root.querySelector('.js-file-input');
      if (!fileInput) return;

      var photoUrl    = root.querySelector('.js-photo-url');
      var stateIdle   = root.querySelector('.js-state-idle');
      var stateLoad   = root.querySelector('.js-state-loading');
      var statePrev   = root.querySelector('.js-state-preview');
      var previewImg  = root.querySelector('.js-preview-img');
      var fileNameEl  = root.querySelector('.js-file-name');
      var removeBtn   = root.querySelector('.js-remove-photo');
      var submitBtn   = root.querySelector('.js-submit-btn');

      function show(el) { el.style.display = 'flex'; }
      function hide(el) { el.style.display = 'none'; }

      function setState(s) {
        if (s === 'idle') {
          show(stateIdle); hide(stateLoad); hide(statePrev);
          hide(removeBtn);
          if (submitBtn) submitBtn.disabled = false;
        } else if (s === 'loading') {
          hide(stateIdle); show(stateLoad); hide(statePrev);
          hide(removeBtn);
          if (submitBtn) submitBtn.disabled = true;
        } else if (s === 'preview') {
          hide(stateIdle); hide(stateLoad); show(statePrev);
          show(removeBtn);
          if (submitBtn) submitBtn.disabled = false;
        }
      }

      function showPreview(src, name) {
        previewImg.src = src;
        fileNameEl.textContent = name.length > 32 ? name.slice(0, 29) + '...' : name;
        setState('preview');
      }

      function localFallback(file) {
        var reader = new FileReader();
        reader.onload = function (e) {
          photoUrl.value = '(Image attached: ' + file.name + ')';
          showPreview(e.target.result, file.name);
        };
        reader.readAsDataURL(file);
      }

      fileInput.addEventListener('change', function () {
        var file = this.files[0];
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
          alert('Please choose an image under 5MB.');
          this.value = '';
          return;
        }

        setState('loading');

        if (apiKey) {
          var fd = new FormData();
          fd.append('image', file);
          fetch('https://api.imgbb.com/1/upload?key=' + apiKey, {
            method: 'POST',
            body: fd
          })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.success) {
              photoUrl.value = d.data.url;
              showPreview(d.data.url, file.name);
            } else {
              localFallback(file);
            }
          })
          .catch(function () { localFallback(file); });
        } else {
          localFallback(file);
        }
      });

      removeBtn.addEventListener('click', function () {
        fileInput.value = '';
        photoUrl.value  = '';
        previewImg.src  = '';
        setState('idle');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
(function() {
  var tooltip = document.getElementById("tooltip");
  var panel = document.getElementById("statePanel");
  var panelTitle = document.getElementById("panelTitle");
  var storeGrid = document.getElementById("storeGrid");
  var closeBtn = document.getElementById("closePanel");
  var mapContainer = document.querySelector(".map-container");

  if (!tooltip || !panel || !mapContainer) return;

  /* Hover tooltip */
  document.querySelectorAll("#us-map .state").forEach(function(state) {
    state.addEventListener("mouseenter", function(e) {
      var name = this.dataset.name;
      var stores = parseInt(this.dataset.stores);
      var hasStores = this.classList.contains("has-stores");
      tooltip.innerHTML = "<h4>" + name + "</h4><p>" +
        (hasStores ? '<span class="tt-count">' + stores + " Total Wine locations</span>" : "Coming soon") +
        "</p>";
      tooltip.style.opacity = "1";
    });

    state.addEventListener("mousemove", function(e) {
      var rect = mapContainer.getBoundingClientRect();
      var x = e.clientX - rect.left + 16;
      var y = e.clientY - rect.top - 10;
      if (x + 200 > rect.width) x = x - 220;
      tooltip.style.left = x + "px";
      tooltip.style.top = y + "px";
    });

    state.addEventListener("mouseleave", function() {
      tooltip.style.opacity = "0";
    });

    /* Click to show stores */
    state.addEventListener("click", function() {
      if (!this.classList.contains("has-stores")) return;
      var name = this.dataset.name;
      var stores = parseInt(this.dataset.stores);
      var cities = (this.dataset.cities || "").split(", ");

      document.querySelectorAll("#us-map .state").forEach(function(s) {
        s.classList.remove("active");
      });
      this.classList.add("active");

      panelTitle.textContent = name.toUpperCase() + " \u2014 " + stores + " LOCATIONS";
      storeGrid.innerHTML = "";

      cities.forEach(function(city) {
        var card = document.createElement("div");
        card.className = "store-card";
        var streets = ["Market St","Main Ave","Commerce Blvd","Retail Dr","Shopping Ctr Pkwy"];
        var fakeAddr = Math.floor(Math.random() * 9000 + 1000) + " " + streets[Math.floor(Math.random() * streets.length)];
        card.innerHTML =
          '<h4>TOTAL WINE &amp; MORE</h4>' +
          '<div class="store-type">Total Wine \u00B7 ' + city + '</div>' +
          '<div class="store-addr">' + fakeAddr + '<br>' + city + '</div>' +
          '<a href="https://www.totalwine.com/store-finder" target="_blank" rel="noopener" class="store-link">Get directions \u2192</a>';
        storeGrid.appendChild(card);
      });

      panel.classList.add("visible");
      panel.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  closeBtn.addEventListener("click", function() {
    panel.classList.remove("visible");
    document.querySelectorAll("#us-map .state").forEach(function(s) {
      s.classList.remove("active");
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
